import { useEffect, useState } from "react";
import { Icon, Label } from "semantic-ui-react";
import { HEARTBEAT_INTERVAL_MS } from "../../context/BookingContext";

function timeAgo(iso) {
  if (!iso) return null;
  const seconds = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ago`;
}

/* Ticks every 5s purely to keep the "Xs/Xm ago" label fresh — lastSyncedAt
   itself only changes when a real refresh (poll or manual) completes. */
/* staleAfterMs derives from the poll interval — one interval plus slack for a
   single missed cycle — so raising the interval can't leave the badge stuck
   on "stale" between two perfectly healthy polls. */
export default function LastUpdatedBadge({
  lastSyncedAt,
  staleAfterMs = HEARTBEAT_INTERVAL_MS * 1.5,
  syncing = false,
}) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 5000);
    return () => clearInterval(id);
  }, []);

  if (syncing) {
    return (
      <Label basic size="tiny" color="blue">
        <Icon name="spinner" loading />
        Syncing…
      </Label>
    );
  }

  if (!lastSyncedAt) return null;
  const stale = Date.now() - new Date(lastSyncedAt).getTime() > staleAfterMs;

  return (
    <Label basic size="tiny" color={stale ? "orange" : "grey"}>
      <Icon name={stale ? "warning circle" : "clock outline"} />
      Updated {timeAgo(lastSyncedAt)}
    </Label>
  );
}
